// extracted by mini-css-extract-plugin
export default {"catalogByServiceItem":"c-h_gs","catalogByServiceItem__title":"c-h_gt"};